import i18n from "src/i18n";
import { LengthOfBoardValue, PurposeValue } from "src/types";
import * as yup from "yup";
import { lengthsOfBoard, purposeValues } from "./constants";

let required = i18n.t("warnings:required");
let notAnEmail = i18n.t("warnings:notAnEmail");

export const formSchema = yup.object({
  email: yup.string().email(notAnEmail).required(required),
  contactStreetAndHouseNumber: yup.string().required(required),
  telephoneNumber: yup.string().required(required),
  contactCityAndZipCode: yup.string().required(required),
  firstName: yup.string().required(required),
  salutation: yup.string().required(required),
  lastName: yup.string().required(required),
  companyName: yup.string(),
  notes: yup.string(),

  streetAndHouseNumber: yup.string().required(required),
  zipCode: yup.string().required(required),
  city: yup.string().required(required),
  purpose: yup.mixed<PurposeValue>().oneOf(purposeValues).required(required),
  dateRange: yup
    .object({
      from: yup.string().required(required),
      to: yup.string().required(required),
    })
    .required(required),
  timeFrom: yup.string().required(required),
  timeTill: yup.string().required(required),
  lengthOfBoard: yup
    .mixed<LengthOfBoardValue>()
    .oneOf(lengthsOfBoard)
    .required(required),
  files: yup.mixed().optional(),
});

export type FormSchema = yup.InferType<typeof formSchema>;
